// extracted by mini-css-extract-plugin
export default {"select":"LXPageSize_select__WZyou"};